import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./pages/home/Header";

// Updated imports according to the new folder structure:
import HomePage from "./pages/home/HomePage";
import SignupPage from "./pages/auth/SignupPage";
import LoginPage from "./pages/auth/LoginPage";
import TeamOptionsPage from "./pages/league/TeamOptionsPage";
import CreateTeamPage from "./pages/league/CreateTeamPage";
import JoinTeamPage from "./pages/league/JoinTeamPage";
import MyTeamsPage from "./pages/league/MyTeamsPage";
import LandingPage from "./pages/home/LandingPage";
import FeaturesAndPricingPage from "./pages/FeaturesAndPricingPage";
import EditTeamsPage from "./pages/league/EditTeamsPage";
import ProtectedTeamDashboard from "./components/ProtectedTeamDashboard";
import DeleteTeamsPage from "./pages/team/DeleteTeamsPage";
import MyAccountPage from "./pages/league/MyAccountPage";
import SupportPage from "./pages/home/SupportPage";

// Import the TestPage to verify Tailwind CSS
import TestPage from "./components/TestPage";

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/team-options" element={<TeamOptionsPage />} />
          <Route path="/create-team" element={<CreateTeamPage />} />
          <Route path="/join-team" element={<JoinTeamPage />} />
          <Route path="/my-teams" element={<MyTeamsPage />} />
          <Route path="/features" element={<FeaturesAndPricingPage />} />
          <Route path="/edit-team/:teamId" element={<EditTeamsPage />} />
          <Route path="/delete-teams" element={<DeleteTeamsPage />} />
          <Route path="/my-account" element={<MyAccountPage />} />
          <Route path="/support" element={<SupportPage />} />
          {/* Nested team dashboard route */}
          <Route path="/team/:teamId/dashboard/*" element={<ProtectedTeamDashboard />} />
          {/* Route for testing Tailwind CSS */}
          <Route path="/test" element={<TestPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
